/***
 * File name: index.js
 *
 * Program Description:
 * Exports of crudModules folder
 *
 * Module Exports:
 * - PDBNF
 * - ASIR
 */
import pdbnf from './dataBreach'
import asir from './securityIncident'
export default {
  pdbnf,
  asir
}
